import React from "react";
import { MapPin, Mail, PhoneCall, Clock } from "lucide-react";

const ContactUs = () => {
  return (
    <section className="lt-contact-wrapper">
      <div className="lt-contact-container">
        {/* Left Info */}
        <div className="lt-contact-info">
          <h2 className="lt-contact-heading">Contact Us</h2>
          <p className="lt-contact-subtext">
            We’re here to answer your queries, schedule a site visit, or help you plan your parking solution.
          </p>

          <div className="lt-contact-detail">
            <MapPin size={20} />
            <span>
              Shop No. 104, First Floor,<br />
              Shabnam Apartment, B P Road,<br />
              Bhayandar (East), Thane – 401105
            </span>
          </div>

          {/* <div className="lt-contact-detail">
            <PhoneCall size={20} />
            <span>+91 98765 43210</span>
          </div>

          <div className="lt-contact-detail">
            <Mail size={20} />
            <span>info@liftechparking.com</span>
          </div>

          <div className="lt-contact-detail">
            <Clock size={20} />
            <span>Mon - Sat: 9:00 AM – 6:00 PM</span>
          </div> */}
        </div>

        {/* Right Form */}
        <div className="lt-contact-form">
          <h3 className="lt-contact-form-heading">Send Us a Message</h3>
          <form className="lt-contact-form-wrapper">
            <div className="lt-form-group">
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" name="name" placeholder="Enter your name" required />
            </div>

            <div className="lt-form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" placeholder="Enter your email" required />
            </div>

            <div className="lt-form-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" name="phone" placeholder="Enter your phone number" />
            </div>

            <div className="lt-form-group">
              <label htmlFor="message">Your Message</label>
              <textarea id="message" name="message" rows="5" placeholder="Write your message here..." required></textarea>
            </div>

            <button type="submit" className="lt-contact-btn">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
